// extracted by mini-css-extract-plugin
export default {"heading":"Home_heading__hcb0e","oldLabel":"Home_oldLabel__9r-NH","newLabel":"Home_newLabel__r4v++","background-information":"Home_background-information__InE2j"};